module.exports = __webpack_public_path__ + "img/symphony_620_lime.3d2add1b.jpg";